const SUCCESS_LOGIN_URL_REDIRECT = '/job-feed/job-reporting';

export default {
   SUCCESS_LOGIN_URL_REDIRECT,
};
